import { twJoin } from "tailwind-merge";

import { ChatMessageRole } from "src/base-components/Chat/types";

type ChatMessageProps = {
  role: ChatMessageRole;
  children: React.ReactNode;
  renderActions?: () => React.ReactNode;
  dataLoc?: string;
  isLegacy?: boolean;
};

export const ChatMessage: React.FC<ChatMessageProps> = ({
  role,
  children,
  renderActions,
  dataLoc,
  isLegacy = false,
}) => {
  const isUserMessage = role === "user";

  return (
    <li className="group flex flex-col gap-y-1" data-loc={dataLoc}>
      {isLegacy && (
        <div className="flex items-center justify-between gap-x-4">
          <span className="font-inter-normal-12px text-gray-500">
            {isUserMessage ? "User" : "Copilot"}
          </span>
          {renderActions?.()}
        </div>
      )}
      <div
        className={twJoin(!isLegacy && isUserMessage && "max-w-[75%] self-end")}
      >
        {children}
      </div>
    </li>
  );
};
